<div class="modal-body pb-3 pt-3 pe-4 ps-4">
    <h5 class="title-step mt-0 mb-3 text-center">Error con el usuario</h5>
    <div>
        <p>Error con el usuario de {{ data.marca }}, contacta con tu GPV</p>
    </div>
    <div class="align-items-center">
        <button class="btn btn-orange d-block w-100" (click)="closeAll()">Ir al inicio</button>
    </div>
</div>
